/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import * as constants from "constants/constants";

class SearchButton extends Component {
  componentDidMount() {
    this.props.onMount();
  }

  componentDidUpdate() {
    this.props.onUpdate();
  }

  render() {
    const { icon, clickHandler, isSearchInputVisible, label, ...otherProps } = this.props;
    if (isSearchInputVisible) {
      return null;
    }
    return (
      <Fragment>
        <ButtonWrapper
          icon={icon}
          clickHandler={clickHandler}
          ariaLabel="arialabel.searchInDocument"
          tooltipString="tooltip.searchInDocument"
          tooltipPlacement={constants.TOOLTIP_BOTTOM_PLACEMENT}
          tooltipDelay={constants.TOOLTIP_DELAY}
          {...otherProps}
        />
        {label}
      </Fragment>
    );
  }
}

SearchButton.propTypes = {
  icon: PropTypes.object.isRequired,
  clickHandler: PropTypes.func.isRequired,
  isSearchInputVisible: PropTypes.bool.isRequired,
  label: PropTypes.string
};

SearchButton.defaultProps = {
  label: null
};

export default SearchButton;
